import { BarChart2, Code2, Globe, Hash, PieChart, Table2, TrendingUp } from "lucide-react";
import { rawColors } from "@magicbi/ui-library";
import type { LucideIcon } from "lucide-react";

export interface StorySqlKindStyle {
  icon: LucideIcon;
  /** The 24px tile behind the icon at rest. */
  bg: string;
  fg: string;
}

const purple: Pick<StorySqlKindStyle, "bg" | "fg"> = { bg: rawColors.primary[100], fg: rawColors.primary[500] };
const teal: Pick<StorySqlKindStyle, "bg" | "fg"> = { bg: rawColors.accent.cross.bg, fg: rawColors.accent.cross.text };
const peach: Pick<StorySqlKindStyle, "bg" | "fg"> = { bg: rawColors.accent.drill.bg, fg: rawColors.accent.drill.text };
const blue: Pick<StorySqlKindStyle, "bg" | "fg"> = { bg: rawColors.accent.infoBlue.bg, fg: rawColors.accent.infoBlue.solid };

/** The icon and tint a chart kind wears in the list (F26). Matches on the kind's lowercase text; unknown kinds get the code glyph. */
export const storySqlKindStyle = (kind?: string): StorySqlKindStyle => {
  const k = (kind ?? "").toLowerCase();
  if (k.includes("kpi")) return { icon: Hash, ...purple };
  if (k.includes("donut") || k.includes("pie")) return { icon: PieChart, ...teal };
  if (k.includes("line") || k.includes("area")) return { icon: TrendingUp, ...peach };
  if (k.includes("table")) return { icon: Table2, ...blue };
  if (k.includes("map")) return { icon: Globe, ...teal };
  if (k.includes("bar") || k.includes("column")) return { icon: BarChart2, ...purple };
  return { icon: Code2, ...purple };
};
